import cn from "classnames";
import { useEffect } from "react";
import { useAppSelector } from "../../store";
import { addDebugHooks } from "../../store/debug";
import { assertNever } from "../../util";
import { Account } from "../Account/Account";
import { Changelog } from "../Changelog/Changelog";
import { Game } from "../Game/Game";
import { Header } from "../Header/Header";
import { HowToPlay } from "../HowToPlay/HowToPlay";
import { KeyboardListener } from "../KeyboardListener/KeyboardListener";
import { LocalStorage } from "../LocalStorage/LocalStorage";
import { NavigationListener } from "../NavigationListener/NavigationListener";
import { PrivacyPolicy } from "../PrivacyPolicy/PrivacyPolicy";
import { ServerListener } from "../ServerListener/ServerListener";
import { Settings } from "../Settings/Settings";
import { Snackbar } from "../Snackbar/Snackbar";
import Stats from "../Stats/Stats";
import { Welcome } from "../Welcome/Welcome";
import styles from "./App.module.css";

export function App() {
  const view = useAppSelector((s) => s.ui.path.view);
  const disableAnimations = useAppSelector((s) => s.settings.disableAnimations);

  useEffect(() => {
    addDebugHooks();
  }, []);

  // Prevent sedecordle form working in iframes
  // if (window.top !== window) {
  //   return (
  //     <p>
  //       Play Sedecordle at{" "}
  //       <a href="https://sedecordle.co" target="_blank" rel="noreferrer">
  //         https://sedecordle.co
  //       </a>
  //     </p>
  //   );
  // }

  return (
    <div
      className={cn(
        styles.main,
        view === "game" && styles.game,
        disableAnimations && styles.disableAnimations
      )}
    >
      <Header />
      {view === "welcome" ? (
        <Welcome />
      ) : view === "game" ? (
        <Game />
      ) : view === "privacy-policy" ? (
        <PrivacyPolicy />
      ) : view === "how-to-play" ? (
        <HowToPlay />
      ) : view === "stats" ? (
        <Stats />
      ) : view === "account" ? (
        <Account />
      ) : (
        assertNever(view)
      )}
      <Changelog />
      <Settings />
      <Snackbar />
      <LocalStorage />
      <KeyboardListener />
      <NavigationListener />
      <ServerListener />
    </div>
  );
}
